import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import BarcodeSummary
  from "./pages/BarcodeSummary";

import ShopsList from "./pages/UsersList";
import UserScanDetails from "./pages/UserScanDetails";
function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Login />}
        />
        <Route
          path="/dashboard"
          element={<Dashboard />}
        />
        <Route
          path="/summary"
          element={<BarcodeSummary />}
        />
        <Route
          path="/shops-list"
          element={<ShopsList />}
        />

        <Route
          path="/user-scans/:username"
          element={<UserScanDetails />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;